"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var AnalyticsProvider_1 = require("../AnalyticsProvider");
var BingProvider = /** @class */ (function (_super) {
    __extends(BingProvider, _super);
    function BingProvider(name, config) {
        var _this = _super.call(this, name) || this;
        _this.config = config;
        return _this;
    }
    /**
     * Custom events currently asked to be tracked.
     *  1. Event Category = onshop
     *  2. Event Label = [ AddToWishlist, Lead,CustomizeProduct, InitiateCheckout , CompleteRegistration ]
     */
    BingProvider.prototype.vehicleAdded = function () {
        this.sendEvent({
            event_label: "AddToWishlist",
            event_category: "onshop",
        });
    };
    BingProvider.prototype.paymentCalcInteraction = function () {
        this.sendEvent({
            event_label: "CustomizeProduct",
            event_category: "onshop",
        });
    };
    BingProvider.prototype.garageInteraction = function () {
        this.sendEvent({
            event_label: "CustomizeProduct",
            event_category: "onshop",
        });
    };
    BingProvider.prototype.continueDeal = function () {
        this.sendEvent({
            event_label: "InitiateCheckout",
            event_category: "onshop",
        });
    };
    BingProvider.prototype.leadFormFinished = function () {
        this.sendEvent({
            event_label: "Lead",
            event_category: "onshop",
        });
    };
    BingProvider.prototype.schedulePickupOrDeliveryFormFinished = function () {
        this.sendEvent({
            event_label: "CompleteRegistration",
            event_category: "onshop",
        });
    };
    /**
     * If we were passed an eventCallback, send the payload there.
     *  This is typical in Electric, where we want to push onto the parent window (dealer website) dataLayer.
     */
    BingProvider.prototype.sendEvent = function (event) {
        this.config.eventCallback(this.config.bingTagId, event);
    };
    return BingProvider;
}(AnalyticsProvider_1.AnalyticsProvider));
exports.default = BingProvider;
